"use client";

import { c as _c } from "react/compiler-runtime";
import { useEffect, useRef, useState } from "react";
import { useQueries } from "@tanstack/react-query";
import { useDialogDetails } from "../../../dialogComponents/DialogProvider";
import { QueryKeys } from "@/constants/queryKeys";
import api from "@/actions/api";
import uuidSlugUtil from "@/utils/uuidSlugUtil";
export function useCompare(slug, originalBusinessType, originalListingType) {
  const $ = _c(20);
  const {
    persistedModals
  } = useDialogDetails();
  const [scrollPosition, setScrollPosition] = useState(0);
  const [maxScroll, setMaxScroll] = useState(0);
  const scrollContainerRef = useRef(null);
  const [selectedItem, setSelectedItem] = useState(null);
  let t0;
  if ($[0] !== slug) {
    t0 = id => id !== slug;
    $[0] = slug;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const candidates = persistedModals.filter(t0);
  const candidateDetails = useQueries({
    queries: candidates.map(_temp)
  });
  let t1;
  if ($[2] !== candidateDetails || $[3] !== originalBusinessType || $[4] !== originalListingType) {
    t1 = (_, i) => {
      const candidate = candidateDetails[i].data?.data?.realEstate;
      return candidate?.businessType === originalBusinessType && candidate?.listingType === originalListingType;
    };
    $[2] = candidateDetails;
    $[3] = originalBusinessType;
    $[4] = originalListingType;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const sameTypeSlugs = new Set(candidates.filter(t1));
  const shouldRender = sameTypeSlugs.size > 0;
  let t2;
  if ($[6] !== selectedItem) {
    t2 = id_2 => selectedItem ? id_2 === selectedItem : true;
    $[6] = selectedItem;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  const toRender = candidates.filter(id_1 => sameTypeSlugs.has(id_1)).filter(t2);
  let t3;
  let t4;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => {
      if (scrollContainerRef.current) {
        const container = scrollContainerRef.current;
        setMaxScroll(container.scrollWidth - container.clientWidth);
        const handleScroll = () => setScrollPosition(container.scrollLeft);
        const handleResize = () => setMaxScroll(container.scrollWidth - container.clientWidth);
        container.addEventListener("scroll", handleScroll);
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
          container.removeEventListener("scroll", handleScroll);
          window.removeEventListener("resize", handleResize);
        };
      }
    };
    t4 = [scrollContainerRef];
    $[8] = t3;
    $[9] = t4;
  } else {
    t3 = $[8];
    t4 = $[9];
  }
  useEffect(t3, t4);
  let t5;
  if ($[10] !== maxScroll || $[11] !== scrollPosition) {
    t5 = direction => {
      if (!scrollContainerRef.current) {
        return;
      }
      const container_0 = scrollContainerRef.current;
      const scrollAmount = container_0.clientWidth * 0.8;
      container_0.scrollTo({
        left: direction === "left" ? Math.max(0, scrollPosition - scrollAmount) : Math.min(maxScroll, scrollPosition + scrollAmount),
        behavior: "smooth"
      });
    };
    $[10] = maxScroll;
    $[11] = scrollPosition;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  const scrollTo = t5;
  const t6 = scrollPosition > 10;
  const t7 = scrollPosition < maxScroll - 10;
  let t8;
  if ($[13] !== scrollTo || $[14] !== selectedItem || $[15] !== shouldRender || $[16] !== t6 || $[17] !== t7 || $[18] !== toRender) {
    t8 = {
      shouldRender,
      toRender,
      selectedItem,
      setSelectedItem,
      scrollContainerRef,
      scrollTo,
      showLeftButton: t6,
      showRightButton: t7
    };
    $[13] = scrollTo;
    $[14] = selectedItem;
    $[15] = shouldRender;
    $[16] = t6;
    $[17] = t7;
    $[18] = toRender;
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  return t8;
}
function _temp(id_0) {
  return {
    queryKey: [QueryKeys.REAL_ESTATE_DETAIL, uuidSlugUtil(id_0, undefined)],
    queryFn: () => api.realEstate.getRealEstateBySlugDetail(id_0),
    enabled: Boolean(id_0)
  };
}